import { EstimateStatus } from '@/gql/graphql';
import { Badge, Tooltip } from '@payaca/ambrosia';
import { PrelineColourVariant } from '@payaca/types/preline';
import { formatDistanceToNow } from 'date-fns';
import { FC } from 'react';

type StatusPresentation = {
  label: string;
  colour: PrelineColourVariant;
};

const STATUS_PRESENTATION: Record<EstimateStatus, StatusPresentation> = {
  DRAFT: { label: 'Draft', colour: 'gray' },
  SENT: { label: 'Sent', colour: 'blue' },
  ARCHIVED: {
    label: 'Archived',
    colour: 'gray',
  },
};

type EstimateStatusBadgeProps = {
  status: EstimateStatus;
  sentAt?: string | null;
  bouncedAt?: string | null;
};

const EstimateStatusBadge: FC<EstimateStatusBadgeProps> = (props) => {
  const { status, sentAt, bouncedAt } = props;

  if (bouncedAt && status !== 'ARCHIVED') {
    return (
      <Badge label="Status: " variant="soft" colour="red" size="sm">
        Bounced
      </Badge>
    );
  }

  const { label, colour } = STATUS_PRESENTATION[status];

  const badge = (
    <Badge label="Status: " variant="soft" colour={colour}>
      {label}
    </Badge>
  );

  if (status === 'SENT' && sentAt) {
    const sentDate = new Date(sentAt);
    if (!Number.isNaN(sentDate.getTime())) {
      return (
        <Tooltip
          tooltipContent={`Sent ${formatDistanceToNow(sentDate, {
            addSuffix: true,
          })}`}
        >
          {badge}
        </Tooltip>
      );
    }
  }

  return badge;
};

export default EstimateStatusBadge;
